<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Veículos do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap> CÓD. COTAÇÃO ENDOSSO </v-flex>
        <v-flex> N. PROPOSTA / ENDOSSO </v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO </v-flex>
        <v-flex>RAZÃO SOCIAL </v-flex>
        <v-flex> CNPJ </v-flex>
        <v-flex> QTD. ÍTENS INCLUSÃO </v-flex>
        <v-flex> VLR.ENDOSSO </v-flex>
        <v-flex>
          <br />
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-btn
            v-if="!selected.length && !corretorParceiroBloquearAcoes"
            color="primary"
            round
            dark
            @click="dialogFile = true"
            >Adicionar Ítem</v-btn
          >
          <v-btn
            @click="filtrarErros = !filtrarErros"
            :class="filtrarErros ? 'activeError' : 'error'"
            v-if="numeroErros && !selected.length && !corretorParceiroBloquearAcoes"
            round
            ><v-icon class="mr-1">error</v-icon
            >{{ `${numeroErros} ${numeroErros === 1 ? "Erro" : "Erros"}` }}
          </v-btn>

          <v-btn
            v-if="mostrarBotaoReavaliar && !corretorParceiroBloquearAcoes"
            @click="reavaliarItem(selected)"
            color="primary"
            round
          >
            Reavaliar Ítem
          </v-btn>

          <v-btn
            @click="deletarItens"
            v-if="selected.length >= 1  && !corretorParceiroBloquearAcoes"
            color="error"
            round
          >
            {{
              selected.length === 1 ? "Excluir Ítem" : "Excluir Ítens"
            }}</v-btn
          >
        </v-card-title>
      </v-card>

      <template>
        <div class="table-width">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="errosFiltrados"
            :search="filtro.pesquisa.conteudo"
            :pagination.sync="pagination"
            :select-all="!camposDisabled && !corretorParceiroBloquearAcoes"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  :input-value="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </td>

              <td class="pa-4 themeGrey--text">
                {{ formatarNumeroItem(props.item.item) }}
              </td>
              <td class="pa-0 item-faltante">
                <v-tooltip
                  v-if="props.item.erro"
                  right
                  color="error"
                  max-width="350px"
                >
                  <template v-slot:activator="{ on }">
                    <span class="error--text" v-on="on">⬤</span>
                  </template>
                  <span
                    >Não foi possivel avaliar este item devido a um ou mais
                    erros nos dados informados. Consulte a FIPE, corrija o(s)
                    erro(s) direto na linha e clique em "Reavaliar Item" para
                    reprocessar os dados.</span
                  >
                </v-tooltip>
              </td>
              <td class="">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.placa"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                  >{{ props.item.placa
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.placa"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>

                <span class="themeGrey--text" v-else>{{
                  props.item.placa
                }}</span>
              </td>
              <td class="">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.chassi"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                  >{{ props.item.chassi
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.chassi"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  props.item.chassi
                }}</span>
              </td>
              <td class="">
                <template v-if="!props.item.fipe || props.item.erro">
                  <v-btn
                  @click="
                      exibeFipe(props.item)
                    "
                    class="error"
                    round
                  >
                    Selecionar
                  </v-btn>
                </template>
                <template v-else>
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.fipe"
                    lazy
                    large
                    persistent
                    @save="saveErro(props.item)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                  >
                    {{ props.item.fipe }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="props.item.fipe"
                        label="Editar"
                        single-line
                        :rules="regras.notNull"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    props.item.fipe
                  }}</span>
                </template>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                  class="item-color"
                  :return-value.sync="props.item.marca"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{ props.item.marca
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.marca"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.marca }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                  class="item-color"
                  :return-value.sync="props.item.modelo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{ props.item.modelo
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.modelo"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.modelo }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoVeiculo"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                  >{{
                    buscarTitulo(props.item.tipoVeiculo, campos.tipoVeiculoList)
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoVeiculoList"
                      v-model="props.item.tipoVeiculo.id"
                      item-text="titulo"
                      item-value="id"
                      label="Editar"
                      :rules="regras.notNull"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.tipoVeiculo, campos.tipoVeiculoList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.catVeiculo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].catVeiculo.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.catVeiculo, campos.catVeiculoList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.catVeiculoList"
                      v-model="props.item.catVeiculo"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.catVeiculo, campos.catVeiculoList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.anoFab"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                  >{{ props.item.anoFab
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.anoFab"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.anoFab }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.anoMod"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                  >{{ props.item.anoMod
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.anoMod"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.anoMod }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.ufPernoite"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].ufPernoite.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.ufPernoite, campos.ufPernoiteList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.ufPernoiteList"
                      v-model="props.item.ufPernoite"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.ufPernoite, campos.ufPernoiteList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.usoDoVeiculo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].usoDoVeiculo.erro,
                    }"
                    >{{
                      buscarTitulo(
                        props.item.usoDoVeiculo,
                        campos.usoDoVeiculoList
                      )
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.usoDoVeiculoList"
                      v-model="props.item.usoDoVeiculo"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(
                      props.item.usoDoVeiculo,
                      campos.usoDoVeiculoList
                    )
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.propriedadeRegistroDoCrlv"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                >
                  <span
                    :class="{
                      errorTaxa:
                        erros[props.item.item].propriedadeRegistroDoCrlv.erro,
                    }"
                    >{{
                      buscarTitulo(
                        props.item.propriedadeRegistroDoCrlv,
                        campos.propriedadeRegistroDoCrlvList
                      )
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.propriedadeRegistroDoCrlvList"
                      v-model="props.item.propriedadeRegistroDoCrlv"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(
                      props.item.propriedadeRegistroDoCrlv,
                      campos.propriedadeRegistroDoCrlvList
                    )
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                {{ props.item.proprietario }}
              </td>
              <td class="themeGrey--text">
                {{ props.item.cpfCnpj }}
              </td>
              <td class="themeGrey--text">
                  {{ props.item.nomeSocial }}
              </td>
              <td class="themeGrey--text">
                {{ traduzValor(props.item.chassiRemarcado) }}
              </td>
              <td class="themeGrey--text">
                {{ traduzValor(props.item.zeroKm) }}
              </td>
              <td class="text-xs-center themeGrey--text">
                {{ formatarData(props.item.saidaDaConcessionaria) }}
              </td>
              <td class="themeGrey--text">
                {{Object.keys(chassiQtdPassageiros).length !== 0 ? chassiQtdPassageiros[props.item.chassi] : props.item.quantPassageiro }}
              </td>
             <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.codigoSistemaRastreamento"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].codigoSistemaRastreamento.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.codigoSistemaRastreamento, campos.codigoSistemaRastreamentoList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.codigoSistemaRastreamentoList"
                      v-model="props.item.codigoSistemaRastreamento"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.codigoSistemaRastreamento, campos.codigoSistemaRastreamentoList)
                  }}
                </span>
              </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua pesquisa não foi encontrada.
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex d-flex justify-center>
        <v-btn
          class="button-custom"
          @click="
            numeroErros > 0 || !validaColunas()
              ? (dialogConfirmacao = true)
              : proximo()
          "
          flat
        >
          Próximo
        </v-btn>
      </v-flex>
    </v-layout>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogAvaliando" max-width="800px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">AVALIANDO ITENS</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12>
                    <span>
                      Por favor, aguarde o processamento. Isso pode levar alguns
                      minutos
                    </span>
                  </v-flex>
                  <v-flex align-center d-flex xs12>
                    <v-progress-linear
                      heigth="2px"
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogAvaliando = false"
                >CANCELAR
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialogFile"
          @update:returnValue="fecharDialogArquivo"
          max-width="800px"
        >
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline"> IMPORTAR PLANILHA</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12 sm6 md3>
                    <a flat @click="salvarPlanilhaModelo">
                      Baixar Modelo de Excel
                    </a>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <label
                      for="file-upload"
                      :class="['button-custom', { disabled: loading }]"
                    >
                      ARQUIVO
                    </label>
                    <input
                      @change="processarArquivo($event)"
                      id="file-upload"
                      type="file"
                      :disabled="loading"
                      v-if="dialogFile"
                    />
                  </v-flex>
                  <v-flex xs12 md7 class="pl-4">
                    <input
                      type="text"
                      class="name-arquivo"
                      readonly
                      v-model="arquivo.name"
                    />
                    <v-progress-circular
                      v-if="loading"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions class="px-5 pb-5">
              <div v-if="!arquivoValido">
                    <small class="text-error">{{
                  erro === undefined || null
                    ? "Não foi possível importar o documento."
                    : erro
                }}</small>
                <br />
                <small class="text-error">
                  {{
                    arquivoFaltante.length
                      ? `${
                          arquivoFaltante.length === 1
                            ? "A coluna"
                            : "As colunas"
                        } "${arquivoFaltante.join('", "')}" ${
                          arquivoFaltante.length === 1
                            ? "não foi encontrada"
                            : "não foram encontradas"
                        }`
                      : "Arquivo inválido"
                  }}
                </small>
              </div>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="fecharDialogArquivo"
                >CANCELAR
              </v-btn>
              <v-btn
                :disabled="loading"
                class="button-customizado"
                flat
                @click="dialog = true"
                >INCLUIR MANUALMENTE</v-btn
              >
              <v-btn
                :disabled="loading"
                class="button-custom"
                flat
                @click="submeterArquivo()"
                >IMPORTAR</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogConfirmacao" max-width="700px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">ATENÇÃO</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12 sm8>
                    <span class="text-permanecer">
                      Existem ítens com erros que ainda não foram corrigidos.
                      <br />
                      Tem certeza de que deseja ir para a próxima etapa sem
                      corrigi-los? <br />
                      Os ítens com erros não serão incluídos na apólice.
                    </span>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="proximo">
                Ignorar os Erros
              </v-btn>

              <v-btn
                class="button-permanecer"
                flat
                @click="dialogConfirmacao = false"
                >Permanecer nesta etapa
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialogFipe"
          hide-overlay
          persistent
          max-width="600px"
        >
          <TabelaFipeModal
            v-if="selecionarModelo"
            :listaVeiculo="listaVeiculo"
            :infoVeiculo="infoVeiculo"
            @fechar="dialogFipe = false"
            @salvar="preencherDadosVeiculo"
            @buscarFipe="buscarFipes"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" hide-overlay fullscreen>
          <AdicionarItemModal
            v-if="dialog"
            @add="dadosPlanilha.push($event), (dialog = false)"
            :item="proximoIndice"
            :dialog="dialog"
            @fechar="dialog = false"
            :campos="campos"
          />
        </v-dialog>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import { adicionarId } from "@/helpers/url-helper.js";
import AdicionarItemModal from "../frota/AdicionarItemModal";
import TabelaFipeModal from "../frota/TabelaFipeModal.vue";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";

export default {
  name: "GridEndossoVeiculosCorretor",
  components: {
    AdicionarItemModal,
    TabelaFipeModal,
  },
  data() {
    return {
      idApolice: null,
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: "",
      },
      conteudoPlanilha: null,
      dialogProgress: false,
      idTipoEndosso: null,
      arquivoFaltante: [],
      arquivoValido: true,
      arquivo: {},
      codigoSistemaRastreamentoList: [],
      dialogFile: false,
      loading: false,
      filtrarErros: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogAvaliando: false,
      dialogConfirmacao: false,
      dialogFipe: false,
      pagination: {
        sortBy: "name",
      },
      selected: [],
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
      },
      campos: {
        numeroRevisao: null,
        erroPlanilha2: null,
        listaEstados: [],
        tipoVeiculoList: [],
        catVeiculoList: [],
        ufPernoiteList: [],
        usoDoVeiculoList: [],
        propriedadeRegistroDoCrlvList: [],
        diasGarantZeroKmList: [],
        tipoCoberturaList: [],
        tipoDeContratacaoList: [],
        tipoDeFranquiaList: [],
        tipoDePropostaList: [],
        ciaRenovacaoList: [],
        kmAssistenciaList: [],
        carroReservaList: [],
        descrCarroceriaList: [],
        descrEquipamentosList: [],
        descrAcessoriosList: [],
        coberturaVidrosList: [],
        codigoSistemaRastreamentoList: [],
        classeList: new Array(11).fill({}).map((_, index) => ({
          id: index,
          titulo: `${index}`,
        })),
        renovacaoSinistroOptions: [
          {
            id: true,
            titulo: "Com sinistro",
          },
          {
            id: false,
            titulo: "Sem Sinistro",
          },
        ],
      },
      resultados: {
        totalPremio: null,
      },

      headers: [
        { text: "ITEM", value: "item" },
        { text: "", value: "", notSortable: true, class: "pa-0" },
        {
          text: "PLACA",
          align: "left",
          value: "placa",
        },
        { text: "CHASSI", value: "chassi" },
        { text: "FIPE", value: "fipe", style: "width: 100px" },
        { text: "MARCA", value: "marca" },
        { text: "MODELO ", value: "modelo" },
        { text: "TIPO VEÍCULO", value: "tipoVeiculo" },
        { text: "CAT. VEÍCULO", value: "catVeiculo" },
        { text: "ANO FAB.", value: "anoFab" },
        { text: "ANO MOD.", value: "anoMod" },
        { text: "UF PERNOITE", value: "ufPernoite" },
        { text: "USO DO VEÍCULO", value: "usoDoVeiculo" },
        {
          text: "PROPRIEDADE (REGISTRO DO CRLV)",
          value: "propriedadeRegistroDoCrlv",
        },
        { text: "PROPRIETÁRIO", value: "proprietario" },
        { text: "CPF/CNPJ", value: "cpfCnpj" },
        { text: "NOME SOCIAL", value: "nomeSocial"},
        { text: "CHASSI REMARCADO", value: "chassiRemarcado" },
        { text: "ZERO KM", value: "zeroKm" },
        { text: "SAÍDA CONCESSIONÁRIA", value: "saidaDaConcessionaria" },
        { text: "QUANT PASSAGEIROS", value: "quantPassageiro" },
        { text: "DISPOSITIVO DE SEGURANÇA", value: "codigoSistemaRastreamento"},
      ],
      chassis: [],
      chassiQtdPassageiros: {},
      dadosPlanilha: [],
      endosso: [],
      selecionarModelo: null,
      idStatusEndosso: null,
      idStatusCorretorReserva: null,
      corretorParceiroBloquearAcoes: false
    };
  },
  computed: {
    ...mapState("formEndosso", [
      "id",
      "proponenteCnpj",
      "proponenteRazaoSocial",
      "idPropostaStatus",
    ]),
    quantidadeItens() {
      return this.$store.getters["formEndosso/quantidadeItem"];
    },

    camposDisabled() {
      return (
        (this.idStatusEndosso > statusEndossoEnum.statusEndosso.SALVO &&
          this.idStatusEndosso != statusEndossoEnum.statusEndosso.PENDENTE) ||
        this.idPropostaStatus == 7 ||
        this.idPropostaStatus == 12
      );
    },

    mostrarBotaoReavaliar() {
      if (this.selected.length !== 1) {
        return false;
      }
      return !!this.erroPlanilha[this.selected[0].item];
    },
    errosFiltrados() {
      return this.filtrarErros && this.numeroErros
        ? this.dadosPlanilha.filter((value) => value.erro)
        : this.dadosPlanilha;
    },
    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },

    proximoIndice() {
      return (
        this.dadosPlanilha.reduce(
          (acc, cur) => (cur.item > acc ? cur.item : acc),
          -1
        ) + 1
      );
    },
    erros() {
      const validar = (ativo, temErro) => {
        if (!ativo) {
          return { ativo: false };
        }
        return {
          ativo: true,
          erro: temErro(),
        };
      };
      return this.dadosPlanilha.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.item]: {
            catVeiculo: validar(
              true,
              () => !cur.catVeiculo || typeof cur.catVeiculo.id !== "number"
            ),

            ufPernoite: validar(
              true,
              () => !cur.ufPernoite || typeof cur.ufPernoite.id !== "number"
            ),

            usoDoVeiculo: validar(
              true,
              () => !cur.usoDoVeiculo || typeof cur.usoDoVeiculo.id !== "number"
            ),

            anoFab: validar(
              true,
              () => !cur.anoFab || typeof cur.anoFab !== "number"
            ),

            codigoSistemaRastreamento: validar(
              true,
              () => !cur.codigoSistemaRastreamento || typeof cur.codigoSistemaRastreamento.id !== "number"
            ),

            propriedadeRegistroDoCrlv: validar(
              true,
              () =>
                !cur.propriedadeRegistroDoCrlv ||
                typeof cur.propriedadeRegistroDoCrlv.id !== "number"
            ),
            fipe: {
              ativo: !(cur.catVeiculo && [6].includes(cur.catVeiculo.id)),
            },
          },
        }),
        {}
      );
    },
  },

  async mounted() {
    this.corretorParceiroBloquearAcoes = this.$route.query.corretorParceiro === 'true';
    this.idTipoEndosso = this.$route.query.idTipoEndosso;
    this.idApolice = this.$route.query.id;
    this.idStatusCorretorReserva = this.$route.query.idStatusCorretorReserva
      ? this.$route.query.idStatusCorretorReserva
      : null;

    if (this.$route.query.numeroRevisao) {
      this.numeroRevisao = this.$route.query.numeroRevisao;
      this.dateInicioEndosso = localStorage.getItem("dateInicio");
      this.dateFimEndosso = localStorage.getItem("dateFim");
      this.$store.commit("startLoading");

      Object.entries(this.$store.getters["formEndosso/infoEndosso"]).forEach(
        ([key, value]) => (this[key] = value)
      );
      this.idStatusEndosso = this.$store.getters["formEndosso/infoEndosso"].idStatusEndosso
      await this.buscarEndosso(this.$route.query.numeroRevisao, this.idStatusEndosso);
      this.$store.commit("endLoading");
    }

    this.buscaOpcoes();
  },
  methods: {
    buscarEndosso(idEndosso, idStatusEndosso) {
      this.$store.commit("startLoading");
      axios
        .get(`${process.env.URL_ENDOSSOMS}/v1/visualizarEndosso${idStatusEndosso == 1 || idStatusEndosso == 8 ? "Salvo" : ''}/${idEndosso}`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          this.endosso = response.data;
          this.endosso.dateInicio = this.dateInicioEndosso;
          this.endosso.dateFim = this.dateFimEndosso;
          this.dadosPlanilha = response.data.itemAdicionadoList;


        })
        .catch((err) => {
          this.$store.commit("endLoading");
        });
    },

    buscarFipes() {
      this.$store.commit('startLoading');
      axios
        .get(
          `${process.env.URL_FIPEMS}/v1/consultarVeiculo?chassi=${this.selecionarModelo.chassi}&placa=${this.selecionarModelo.placa}
            `,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then( response => {
          return response.data;

        }).then(data => {
          this.listaVeiculo = data.veiculoList;
          const {agregadosII, ...info} = data;
          this.infoVeiculo = {...agregadosII, ...info};
          this.dialogFipe = true
          this.$store.commit("endLoading");

        })
        .catch((err) => {
          console.log(err);
          this.$store.commit("endLoading");
        });
    },

    submeterArquivo() {
      this.loading = true;
      const formData = new FormData();
      formData.append("planilha", this.arquivo);
      formData.append("ignorarErros", false)
      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/validarPlanilha`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response.data) {
            this.arquivoValido =
              typeof response.data.valido === "boolean"
                ? response.data.valido
                : true;
            this.arquivoFaltante =
              response.data.naoEncontrados instanceof Array
                ? response.data.naoEncontrados
                : [];
            this.conteudoPlanilha =
              response.data.conteudo instanceof Array
                ? response.data.conteudo
                : [];
            this.erroPlanilha2 =
              response.data.erros instanceof Array ? response.data.erros : [];
          }
          if (this.arquivoValido) {
            this.avaliarPlanilha();
          }
        })
        .catch(error => {
          this.arquivoValido = false;
          this.erro = error.response.data.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async buscarNumPassageiro(chassis){
      const chassiModel = {
        chassis: chassis
      }
      var response = await axios.post(
        `${process.env.URL_APOLICEMS}/v1/buscarNumeroPassageiro/`,chassiModel,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      for(var agregado of response.data){
        this.chassiQtdPassageiros[agregado.nrChassi] = agregado.nrQtdPax
        for(var planilha of this.conteudoPlanilha){
          if(planilha.chassi === agregado.nrChassi){
          planilha.quantPassageiro = agregado.nrQtdPax
          }
        }

      }

    },
    avaliarPlanilha() {
      const self = this;
      if (!(this.conteudoPlanilha instanceof Array)) {
        return;
      }

      this.$store.commit("formEndosso/setConteudoPlanilha", {
        dados: this.conteudoPlanilha.map((e) => {
          const item = this.erroPlanilha2.find((v) => v.item === e.item);
          return { ...e, erro: item && item.erro };
        }),
      });
      this.$store.commit("formEndosso/setErroPlanilha", {
        dados: this.erroPlanilha2,
      });
      this.dialogProgress = false;
      this.snackbar.visivel = true;
      this.snackbar.sucesso = true;
      setTimeout(() => {
        this.snackbar.mensagem = "Arquivo importado com sucesso";
        this.fecharDialogArquivo();

        if (this.numeroRevisao) {
          self.conteudoPlanilha.forEach(function (objeto) {
            self.dadosPlanilha.push(objeto);
          });
        } else {
          this.dadosPlanilha =
            this.$store.getters["formEndosso/cloneConteudoPlanilha"];
        }
        this.dialogProgress = true;
      }, 1000);
    },

    atualizarGrid() {
      const self = this;
      this.$store.commit("formEndosso/setConteudoPlanilha", {
        dados: this.conteudoPlanilha.map((e) => {
          const item = this.erroPlanilha2.find((v) => v.item === e.item);
          return { ...e, erro: item && item.erro };
        }),
      });
      this.$store.commit("formEndosso/setErroPlanilha", {
        dados: this.erroPlanilha2,
      });
    },

    processarArquivo(event) {
      this.arquivo = event.target.files[0] || {};
    },
    salvarPlanilhaModelo() {
      this.$store.commit("startLoading");
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/downloadPlanilhaModelo`, {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          const arquivo = response.data;
          const blob = new Blob([arquivo], {
            type: response.headers["content-type"],
          });
          saveAs(blob, "PlanilhaModelo.xlsx");
        })
        .catch((err) => {})
        .finally(() => {
          this.$store.commit("endLoading");
          this.atualizarGrid();
        });
    },
    fecharDialogArquivo() {
      this.dialogFile = false;
      this.arquivoValido = true;
      this.arquivoFaltante = [];
      this.arquivo = {};
    },
    formatarErro(novosErros, listaErros = {}) {
      return {
        ...listaErros,
        ...novosErros.reduce(
          (acc, cur) => ({ ...acc, [cur.item]: cur.erro }),
          {}
        ),
      };
    },
    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
    },
    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    async reavaliarItem(item) {
      this.dialogAvaliando = true;
      try {
        const response = await axios.post(
          `${process.env.URL_PLANILHAMS}/v1/revalidarCamposPlanilha`,
          item,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        );

        response.data.forEach((e) => {
          if (e.erro) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Dados inválidos.";
            return;
          }
          if (
            e.item in this.erroPlanilha &&
            e.erro !== this.erroPlanilha[e.item]
          ) {
            for (let i = 0; i < this.dadosPlanilha.length; i++) {
              if (this.dadosPlanilha[i].item === e.item) {
                this.dadosPlanilha[i].erro = e.erro;
                this.snack = true;
                this.snackColor = "success";
                this.snackText = "Dados validados com sucesso!";
                break;
              }
            }
          }
        });
      } catch (error) {
        return error;
      } finally {
        this.dialogAvaliando = false;
      }
    },

    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";

    },

    buscarTitulo(entity, list) {
      if (entity) {
        const campo = list.find(
          (item) => item === entity.id || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    deletarItens() {
      const selecionados = this.selected.map((e) => e.item);
      this.dadosPlanilha = this.dadosPlanilha.filter(
        (e) => !selecionados.includes(e.item)
      );
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dadosPlanilha.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    saveErro(item) {
      this.save();
      item.erro = true;
    },

    saveErro(item) {
      this.save();
      item.erro = true;
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Editar cancelado";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar aberto";
    },
    close() {
      console.log("Dialog closed");
    },
    filtroFunctions: function () {
      const self = this;
      return {
        abrirFiltroPesquisa: function () {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function () {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        },
      };
    },

    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "tipoVeiculoList",
            "catVeiculoList",
            "ufPernoiteList",
            "usoDoVeiculoList",
            "propriedadeRegistroDoCrlvList",
            "diasGarantZeroKmList",
            "tipoCoberturaList",
            "tipoDeContratacaoList",
            "tipoDeFranquiaList",
            "tipoDePropostaList",
            "ciaRenovacaoList",
            "kmAssistenciaList",
            "carroReservaList",
            "descrCarroceriaList",
            "descrEquipamentosList",
            "descrAcessoriosList",
            "coberturaVidrosList",
            "codigoSistemaRastreamentoList",
          ].forEach((nome) => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    validaColunas() {
      return Object.values(this.erros).every((item) =>
        Object.values(item).every((subItem) => subItem.erro !== true)
      );
    },

    voltar: function () {
      this.$router.push(
        `/corretor/InfoEndosso?id=${
          this.idApolice
        }${
          this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
        }&idTipoEndosso=${
          this.idTipoEndosso
        }${
          this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
        }${
          this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
        }${
          this.$route.query.corretorParceiro === 'true' ? `&corretorParceiro=true` : ''
        }`
      );
    },
    passarValorNumeroPassageiro(){
      if(this.conteudoPlanilha) {
        for(var conteudo of this.conteudoPlanilha){
          for(var dados of this.dadosPlanilha){
            if(conteudo.chassi === dados.chassi){
            dados.quantPassageiro = conteudo.quantPassageiro
            }
          }

        }
      }
    },
    proximo() {
      this.passarValorNumeroPassageiro()
      const dadosAtualizados = {
        dados: this.dadosPlanilha,
      };

      /* Lógica para verificar se há chassi duplicado */
      this.chassis.length = 0;

      for(var chassi of dadosAtualizados.dados){
        this.chassis.push(chassi.chassi)
      }

      const chassisRepetidos = this.chassis.filter((e, i, a) => a.indexOf(e) !== i);

      if (chassisRepetidos.length > 0) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Erro no chassi: ${chassisRepetidos[0]}. Possui um ou mais itens com o mesmo chassi.`;
        return;
      }
      /* -------------------------------------------- */

      /* Verifica se o campo Modelo tem mais de 65 caracteres */
      for (var item of dadosAtualizados.dados) {
        if (item.modelo.length > 65) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `[Erro no item ${item.item}] O campo 'Modelo' não pode ultrapassar os 65 caracteres.`;
        return;
        }
      }
      /* -------------------------------------------- */

      this.$store.commit("formEndosso/setItensAdicionados", dadosAtualizados);
      this.$router.push(
        `/corretor/coberturas?id=${
          this.idApolice
        }${
          this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
        }&idTipoEndosso=${
          this.idTipoEndosso
        }${
          this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
        }${
          this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
        }${
          this.$route.query.corretorParceiro === 'true' ? `&corretorParceiro=true` : ''
        }`
      );
    },

    exibeFipe(item) {

    item.dcRetorno = item.dcRetorno == undefined ? null : item.dcRetorno;
    if (item.dcRetorno === null) {
      this.selecionarModelo = item;
      this.buscarFipes();
    } else {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = item.dcRetorno;
      return;
    }
  },

    comparador(itemLista, item) {
      if (item && item.id) {
        return item.id === itemLista.id;
      }
      return false;
    },

    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    },

    async preencherDadosVeiculo(veiculoSelecionado, infoVeiculo) {
      if (veiculoSelecionado && veiculoSelecionado.codigoFipe) {
        this.selecionarModelo.fipe = veiculoSelecionado.codigoFipe;
        this.selecionarModelo.modelo = veiculoSelecionado.modelo;
        this.selecionarModelo.anoMod = veiculoSelecionado.anoModelo;
        this.selecionarModelo.marca = veiculoSelecionado.marca;
        this.selecionarModelo.tipoVeiculo = veiculoSelecionado.tipoVeiculo;
        this.selecionarModelo.chassi = infoVeiculo.chassi;
        this.selecionarModelo.placa = infoVeiculo.placa;
        await this.reavaliarItem([this.selecionarModelo]);
        this.selecionarModelo = null;
        this.dialogFipe = false;
      }
    },
  },
};
</script>

<style>
.background {
  background-color: white;
}

.table-width > div > div > table {
  width: 3000px;
}

.item-color > div > a {
  color: #757575 !important;
}

.activeError {
  border: 1px solid red;
  color: red !important;
}

.button-permanecer {
  background: #00456e;
  color: white !important;
}

.text-permanecer {
  font-weight: bold;
  color: #757575 !important;
}
.errorTaxa {
  color: red !important;
  font-weight: bold;
}

.table-grid thead {
  background-color: #00456e;
}
.table-grid .column {
  color: #fff !important;
}

.table-grid th i {
  color: #fff !important;
}

.dialog {
  background: #eaeaea !important;
}

.headline {
  color: #fff;
  font-size: 14px !important;
}

.text-error {
  color: #f45353;
  font-weight: bold;
}

.name-arquivo {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 2px;
}

input[type="file"] {
  display: none;
}

.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}
.button-customizado {
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 3px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

.button-customizado:hover {
  background-color: #063f57;
}

.button-custom:hover {
  background-color: #063f57;
}

.disabled,
.v-btn.button-custom:disabled, .button-customizado:disabled {
  cursor: default;
  background-color: #063f57;
  color: #aaaaaa !important;
}

.disabled:hover {
  background-color: #063f57;
}

.click {
  cursor: pointer;
}
.size {
  size: 1;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/GridEndossoVeiculosCorretor.vue